interface SuccessScreenProps {
  cardUrl: string;
  onFinish: () => void;
}

export function SuccessScreen({ cardUrl, onFinish }: SuccessScreenProps) {
  return (
    <div className="wrap success-screen">
      <h1>Cronyl</h1>

      <div className="done-icon" aria-hidden="true">
        ✓
      </div>

      <h2 className="success-title">Your Cronyl Card is Ready</h2>
      <p className="success-subtitle">
        Your wallet has been successfully linked to your Cronyl Card.
        <br />
        The configuration is permanently locked.
      </p>

      <div className="card-link">
        <span className="url-label">Card URL</span>
        <code className="url-value">{cardUrl}</code>
      </div>

      <p className="hint">Anyone who taps your card will be taken to your payment page.</p>

      <button type="button" className="btn btn-finish" onClick={onFinish}>
        Finish
      </button>
    </div>
  );
}
